// import { update } from "lodash";

let URL;
let appMode = process.env.REACT_APP_ENV || process.env.NODE_ENV;
let ASSET_URL = "http://103.189.173.7:3369/api";

if (appMode === "development") {
  // URL = "https://lmrbhhfp-8000.inc1.devtunnels.ms/";
  // URL = "http://127.0.0.1:8000/";
  // URL = "http://45.194.47.66:8010/";
  // URL = "http://44.201.121.78:8000/";
  URL = "https://back.ankkurfundraise.com/";
} else {
  // URL = "http://103.189.173.7:3369/api";
  // URL = "http://localhost:3369/api";
  // URL = "https://jf9m83zh-8000.inc1.devtunnels.ms";
  // URL = "http://45.194.47.66:8010/";
  // URL = " http://45.194.47.66:3550";
  // URL = "http://44.201.121.78:8000/";
  URL = "https://back.ankkurfundraise.com/";
  //URL = "https://myhealth.medivastsolutions.net/"
  // URL = "https://fznj4r32-8001.inc1.devtunnels.ms/";
}

let apiPath = {
  baseURL: URL,
  assetURL: ASSET_URL,
  dashboard: "admin/dashboard",

  // Auth API
  logout: "marketplace-admin/api/logout/",

  login: "marketplace-admin/api/login/",
  profile: "admin/auth/get-profile",
  updateProfile: "admin/auth/update-profile",
  changePassword: "admin/auth/change-password",
  updateAppSetting: "admin/auth/update-app-setting",
  forgotPassword: "admin/auth/forgot-password",
  verifyOTP: "admin/auth/verify-otp",
  resetPassword: "admin/auth/reset-password",

  //notification
  notification: "admin/notification",
  notificationUser: "admin/notification/notification-user",

  //help-center
  helpCenter: "admin/help-center",

  // Other APIs
  customerManager: "admin/user",
  postManager: "admin/posts",
  productManager: "admin/products",
  productCategories: "admin/products/categories",
  productAddCategory: "admin/products/add-category",
  productUpdateCategory: "admin/products/update-category",
  productDeleteCategory: "admin/products/categories",
  categories: "marketplace-admin/api/categories/",
  categoryPhotoDelete: (id) =>
    `marketplace-admin/api/categoriesImageDelete/${id}/`,
  attributes: "marketplace-admin/api/attributes/",
  documentCategories: "document-categories",
  labs: "labs",
  doctors: "doctors",
  vendorSubscriptionManager: "admin/vendor-subscription",
  userSubscriptionManager: "admin/user-plans",
  subscriptions: "admin/subscriptions",
  setCommission: "admin/auth/commission",
  teamManager: "admin/team",
  surveyManger: "admin/survey",
  vendors: "admin/vendors",
  orders: "marketplace-admin/api/orders/",
  ordersSummary: "marketplace-admin/api/orders/summary/",

  marketPlaceProductCreate: "marketplace-admin/api/products/create/",
  marketPlaceProductList: "marketplace-admin/api/product_list/",
  marketPlaceProductView: "marketplace-admin/api/product_view/",
  marketPlaceProductUpdate: "marketplace-admin/api/products/update/",
  marketPlaceProductStatus: (id) =>
    `marketplace-admin/api/products/toggle_status/${id}/`,
  marketPlaceProductDelete: "marketplace-admin/api/products/delete/",
  activeCategoryList: "api/v1/marketplace/category_list/",
  imageUpload: "api/organizer/image_upload",
  addAttribute: "marketplace-admin/api/attributes/create/",
  updateAttribute: (id) => `marketplace-admin/api/attributes/update/${id}/`,
  statusUpdateAttribute: (id) =>
    `marketplace-admin/api/attributes/toggle_status/${id}/`,
  deleteAttribute: (id) => `marketplace-admin/api/attributes/delete/${id}/`,
  listAttribute: "marketplace-admin/api/attributes/",
  activeAttribute: "marketplace-admin/api/attributes/active/",
  getTotalOrderList: "marketplace-admin/api/get_total_order_list/",
  orderDetails: (id) => `marketplace-admin/api/order_detail/${id}/`,
  createAdminEmail: "marketplace-admin/api/admin-emails/create/",
  listAdminEmail: "marketplace-admin/api/admin-emails/",
  deleteAdminEmail: (id) => `marketplace-admin/api/admin-emails/delete/${id}/`,
  updateAdminEmail: (id) => `marketplace-admin/api/admin-emails/update/${id}/`,
  userOrderList: "marketplace-admin/api/users-orders-summary/",
  userOrderDetails: (id) => `marketplace-admin/api/users-detail/${id}/`,
  // Dashboard endpoints
  dashboardOverview: "marketplace-admin/api/dashboard/overview/",
  dashboardStockThreshold: "marketplace-admin/api/dashboard/stock-threshold/",
  dashboardStoreStats: "marketplace-admin/api/dashboard/store-stats/",
  dashboardVisitors: "marketplace-admin/api/dashboard/visitors/",
  dashboardSalesChart: "marketplace-admin/api/dashboard/sales-chart/",
  dashboardComplete: "marketplace-admin/api/dashboard/complete/",
  websiteStatusChange: "marketplace-admin/api/website-status-change/",
  getWebsiteStatus: "marketplace-admin/api/get-website-status/",
  manageMaintenance: (id) => `marketplace-admin/api/website-maintenance/${id}/`,
  // Finance APIs
  finance: {
    transactions: "admin/finance/transactions",
    payouts: "admin/finance/payouts",
    expenses: "admin/finance/expenses",
    tokens: {
      issued: "admin/finance/tokens/issued",
      redeemed: "admin/finance/tokens/redeemed",
      issuedExport: "admin/finance/tokens/issued/export",
      redeemedExport: "admin/finance/tokens/redeemed/export",
    },
    ledger: "admin/finance/ledger",
    ledgerExport: "admin/finance/ledger/export",
  },

  // Auctions APIs
  auctions: {
    list: "admin/auctions",
    requests: "admin/auctions/requests/list",
    export: "admin/auctions/export",
    close: "admin/auctions",
    delete: "admin/auctions",
    cancel: "admin/auctions",
    selectWinner: "admin/auctions",
    approveRequest: "admin/auctions/requests",
    rejectRequest: "admin/auctions/requests",
  },

  // Games APIs
  games: {
    list: "admin/games",
    genres: "admin/genres",
    tiers: "admin/games",
    leaderboard: "admin/games",
  },

  // Global Ranks APIs
  globalRanks: {
    list: "admin/global-ranks",
    create: "admin/global-ranks",
    update: "admin/global-ranks",
    delete: "admin/global-ranks",
    status: "admin/global-ranks",
    leaderboard: "admin/global-ranks/leaderboard",
  },

  // Tournaments APIs
  tournaments: {
    list: "admin/tournaments",
    leaderboard: "admin/tournaments",
  },

  // Global Badges APIs
  badges: {
    list: "admin/badges",
    create: "admin/badges",
    update: "admin/badges",
    delete: "admin/badges",
    status: "admin/badges",
  },

  // Content APIs
  listContent: "admin/content/list",
  editContent: "admin/content/edit",
  statusContent: "admin/content/status",
  viewContent: "admin/content/view",

  common: {
    userOrVendors: "common/user-or-vendor",
    vendors: "common/vendor",
  },
};

export default apiPath;
